export var PlaybackErrors;
(function (PlaybackErrors) {
    PlaybackErrors["PLAY_NOT_AUTHORIZED"] = "PLAY_NOT_AUTHORIZED";
})(PlaybackErrors || (PlaybackErrors = {}));
